import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { SuccessfulEnrichment } from 'hooks/useGruAgent/types';

type State = {
  selectedSuggestion: string | null;
  agentProposal: SuccessfulEnrichment | null;
};

const initialState: State = {
  selectedSuggestion: null,
  agentProposal: null,
};

export const useAgentSuggestionStore = create(
  immer<State>(() => ({
    ...initialState,
  })),
);

export const openAgentSuggestionModal = (suggestion: string, agentProposal: SuccessfulEnrichment) =>
  useAgentSuggestionStore.setState({ selectedSuggestion: suggestion, agentProposal });

export const closeAgentSuggestionModal = () =>
  useAgentSuggestionStore.setState({ selectedSuggestion: null, agentProposal: null });

export const cleanAgentSuggestionStore = () => useAgentSuggestionStore.setState(initialState);
